export const licenseHeaderLabels: Record<string, string> = {
  // Waitlisted license application labels
  waitlistPosition: 'Waitlist current position',

  // License application labels
  appDate: 'Application date',
  appNumber: 'Application number',
  appName: 'Applicant name',

  // License labels
  issueDate: 'Issue date',
  expirationDate: 'Expiration date',
  licenseNumber: 'License number',
  licenseHolder: 'License holder',
};
